"use client";

import { useUserStore, useFormStore } from "@/core/stores";
import { handleSignOut } from "@/features/auth-functions";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { toast } from "sonner";

export function useSignOut() {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { resetUser } = useUserStore();
  const { resetForms } = useFormStore();

  const signOut = async () => {
    setLoading(true);
    try {
      const res = await handleSignOut();
      if (res.error) return alert(res.error);
      router.push("/sign-in");
      resetUser();
      resetForms();
      toast("로그아웃되었어요.");
    } catch (e) {
      const error = e as Error;
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    signOut,
  };
}
